import { StyleSheet } from 'aphrodite/no-important';
import {
  palettes,
  spacers,
  fonts,
  typography,
  borderRadius,
} from '@trainline/depot-web/css/themes/trainline';

import * as colors from '@contactcentre-web/styles/colors';

export default StyleSheet.create({
  formContainer: {
    padding: `${spacers.dp_s24} 0 0 0`,
    display: 'flex',
    flexDirection: 'column',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    rowGap: `${spacers.dp_s16}`,
  },
  row: {
    display: 'flex',
    gap: spacers.dp_s12,
    justifyContent: 'space-between',
    border: `1px solid ${palettes.dp_app_backdrop_darker}`,
    padding: spacers.dp_s12,
    borderRadius: borderRadius.dp_r8,
    alignItems: 'center',
  },
  rowError: {
    borderColor: 'red',
  },
  label: {
    fontWeight: fonts.dp_font_weight_regular,
    color: palettes.dp_app_text_base,
  },
  gray: {
    fontWeight: fonts.dp_font_weight_regular,
    color: palettes.dp_app_text_subdued,
  },
  paymentLabelContainer: {
    marginBottom: spacers.dp_s8,
  },
  amount: {
    fontSize: typography.dp_title2_font_size_m,
    lineHeight: typography.dp_title2_line_height_m,
    fontWeight: fonts.dp_font_weight_bold,
  },
  footerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  detailsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: spacers.dp_s16,
  },
  detailsItem: {
    width: '50%',
  },
  proceedButton: {
    display: 'inline-flex',
    height: '50px',
  },
  pnr: {
    display: 'inline-flex',
    gap: spacers.dp_s8,
    marginLeft: spacers.dp_s16,
  },
  productsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacers.dp_s12,
  },
  productLabel: {
    display: 'flex',
    alignItems: 'center',
    fontSize: typography.dp_body_font_size,
    fontWeight: 'bold',
  },
  productsHeader: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  productsError: {
    color: colors.negative.base,
  },
});
